import { Box } from '@mui/material';
import { KanbanColorPicker } from '../../config/KanbanColor';
import kanbanService from '../../service/kanban.service';
import { ButtonUI, DialogUI } from '../Interface';

const ColorDialog = ({ open, handleClose, data, setKanbanData }) => {
  const handleChangeColor = (color) => {
    kanbanService.updateKanbanColorLink(data.subMenuUrl, data.lineId, color).then(() => {
      setKanbanData((prev) =>
        prev.map((col) => ({
          ...col,
          items: col.items.map((it) => (it.id === data.lineId ? { ...it, color: color } : it)),
        }))
      );
      handleClose();
    });
  };

  const handleDeleteColor = () => {
    kanbanService.deleteKanbanColorLink(data.subMenuUrl, data.lineId).then(() => {
      setKanbanData((prev) =>
        prev.map((col) => ({
          ...col,
          items: col.items.map((it) => (it.id === data.lineId ? { ...it, color: '' } : it)),
        }))
      );
    });
    handleClose();
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Szín megadása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '450px',
          },
        },
      }}
    >
      <Box mt="1rem" display="flex" flexWrap="wrap" gap="0.3rem" justifyContent="center">
        {KanbanColorPicker.map((item) => (
          <Box
            height="40px"
            width="40px"
            borderRadius="50%"
            border="2px solid lightgrey"
            sx={{
              cursor: 'pointer',
            }}
            backgroundColor={item}
            onClick={() => handleChangeColor(item)}
          />
        ))}
        <ButtonUI text="Szín törlése" className="bg-warning mt-3 -mb-4" onClick={() => handleDeleteColor()} />
      </Box>
    </DialogUI>
  );
};

export default ColorDialog;
